import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ambientes-urbanos',
  templateUrl: './ambientes-urbanos.component.html',
  styleUrls: ['./ambientes-urbanos.component.css']
})
export class AmbientesUrbanosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
